import { Component } from '@angular/core';

@Component({
  selector: 'rid-spacer',
  imports: [],
  templateUrl: './rid-spacer.html',
})
export class RidSpacer {}
